import React from 'react';
import {
  ActiveStatus,
  ErrorStatus,
  ProgressStatus,
  WarningStatus,
} from 'components/status';
import { checkIsOfficeHours, checkIsUpdateNow, getPolicyStatus } from 'helpers';
import { IPolicy } from 'types';
import { PolicyStatus, POLICY_STATUS_TOOLTIPS } from 'constants/policy';

interface IPolicyStatusProps {
  policy: IPolicy;
  progress?: number;
  hideTooltips?: boolean;
  showUpdateNow?: boolean;
}

const PolicyItemStatus = ({
  policy,
  progress,
  hideTooltips,
  showUpdateNow,
}: IPolicyStatusProps) => {
  if (policy.data === 'bundle') {
    return (
      <ProgressStatus
        progress={progress}
        tooltip="We’re picking up your policy information. If you have more documents, simply add more."
      />
    );
  }

  const inOffice = checkIsOfficeHours() ? 'in' : 'out';
  const status = getPolicyStatus(policy);
  const tooltip =
    hideTooltips || policy.employerId ? '' : POLICY_STATUS_TOOLTIPS[status];

  switch (status) {
    case PolicyStatus.CANCELLED:
      const expired = 'Expired';
      const expiredToolTip = POLICY_STATUS_TOOLTIPS[PolicyStatus.EXPIRED];
      return <ErrorStatus tooltip={expiredToolTip} text={expired} />;
    case PolicyStatus.EXPIRED:
      const text =
        showUpdateNow && checkIsUpdateNow(policy)
          ? 'Update now'
          : 'Expiring soon';
      return <ErrorStatus tooltip={tooltip} text={text} />;
    case PolicyStatus.FINISH_SETUP:
      return <WarningStatus tooltip={tooltip} text="Finish set up" />;
    case PolicyStatus.PROCESSING:
      return <ProgressStatus tooltip={tooltip} progress={progress} />;
    case PolicyStatus.IN_REVIEW:
      return (
        <WarningStatus
          tooltip={!hideTooltips && POLICY_STATUS_TOOLTIPS[status][inOffice]}
          text="In review"
        />
      );
    case PolicyStatus.INCOMPLETE:
      return <WarningStatus tooltip={tooltip} text="Info missing" />;
    case PolicyStatus.RENEWING:
      return <ActiveStatus tooltip={tooltip} text="Renewing soon" />;
    default:
      return <ActiveStatus tooltip={tooltip} text="Active" />;
  }
};

export default PolicyItemStatus;
